var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupBlueSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "bho5a",
    d: "M363.072 295H362.928c-2.293 0-3.763-.301-4.375-.898-2.103-.212-2.553-1.033-2.553-1.695l.005-.095.191-1.017c.59-3.173 2.124-3.934 4.933-4.289a.788.788 0 0 1 .824.498c.318.805.793 1.572 1.046 1.8.232-.214.688-.92 1.036-1.8a.786.786 0 0 1 .821-.498c2.768.35 4.38 1.141 4.97 4.317l.164.962c.005.028.01.094.01.122 0 .662-.45 1.483-2.553 1.695-.613.597-2.082.898-4.375.898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5b",
    d: "M360.365 282.111c1.613-.052 2.581-.456 3.227-1.349a.5.5 0 0 1 .881.14c.325 1.011.667 1.209 1.149 1.209h.481c-.136-2.09-1.154-3.111-3.106-3.111-1.954 0-2.972 1.024-3.107 3.118z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5c",
    d: "M365.623 283.11c-.94 0-1.462-.514-1.787-1.13-1.031.922-2.355 1.095-3.447 1.13l-.889.012c.013.727.338 1.276.836 1.469.43 1.599 1.323 2.409 2.662 2.409 1.338 0 2.233-.811 2.662-2.412.495-.2.826-.76.836-1.477z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5d",
    d: "M355.214 291.11c.606-3.26 2.244-4.423 4.7-4.921a5.219 5.219 0 0 1-.335-.72c-.226.405-.443.707-.58.833-.253-.226-.727-.994-1.046-1.799a.788.788 0 0 0-.823-.498c-2.81.355-4.344 1.116-4.933 4.29l-.191 1.016a1.512 1.512 0 0 0-.006.095c0 .663.45 1.483 2.553 1.695.147.143.346.269.592.378z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5e",
    d: "M359.591 277.762a.501.501 0 0 1 .881.14c.086.267.174.475.264.64.352-.205.754-.35 1.198-.439-.372-1.403-1.335-2.103-2.937-2.103-1.954 0-2.972 1.023-3.107 3.117l.475-.006c1.613-.052 2.581-.456 3.226-1.349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5f",
    d: "M356.336 281.591c.388 1.443 1.158 2.237 2.288 2.379a3.165 3.165 0 0 1-.127-.893c0-.303 0-.91.427-1.405.124-1.047.473-1.885 1.026-2.495-.04-.064-.079-.13-.115-.197-1.03.922-2.354 1.095-3.447 1.13l-.888.012c.013.726.337 1.277.836 1.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5g",
    d: "M373.986 289.285l-.164-.962c-.591-3.176-2.202-3.967-4.97-4.317a.786.786 0 0 0-.822.498c-.347.88-.803 1.586-1.036 1.8-.144-.13-.361-.44-.58-.83a5.255 5.255 0 0 1-.334.718c2.469.502 4.115 1.672 4.725 4.948l.057.334a2.01 2.01 0 0 0 .58-.372c2.104-.212 2.553-1.033 2.553-1.695 0-.028-.005-.094-.009-.122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5h",
    d: "M367.075 281.672c.427.494.427 1.102.427 1.405 0 .318-.047.617-.129.894 1.132-.142 1.903-.937 2.29-2.383.496-.199.826-.759.837-1.477h-.873c-.94 0-1.462-.515-1.788-1.131a4 4 0 0 1-1.359.788c.306.525.507 1.162.595 1.904"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bho5i",
    d: "M365.791 278.928c.802-.203 1.375-.575 1.802-1.165a.5.5 0 1 1 .881.14c.325 1.01.667 1.208 1.149 1.208h.481c-.136-2.09-1.154-3.111-3.106-3.111-1.602 0-2.565.701-2.938 2.103.687.138 1.268.414 1.732.825"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352 -276)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5d"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5e"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5g"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5h"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#bho5i"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBlueSmall);
export default __webpack_public_path__ + "static/media/group-blue-small.51536053109e51d594f0f7377ca68216.svg";
export { ForwardRef as ReactComponent };